const LogStatus = Object.freeze({
  QUEUED: 'queued',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  ERROR: 'error',
});

export default LogStatus;
